import React from 'react'
import PageNotFound from '../../assets/img/farm-404.png'

export default function index() {
    return <div style={{ display: 'table-cell', textAlign: 'center', verticalAlign: 'middle', width: '100%', height: '100%' }}>
        <img src={PageNotFound} alt='Page Not Found' style={{ maxWidth: '100%', maxHeight: '100%', margin: 'auto', display: 'block' }} />
    </div>
}
